var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"catalogues-card__content"},_vm._l((_vm.lines),function(line,index){return _c('div',{key:index},[_c('strong',[_vm._v(_vm._s(_vm.fields[index])+" :")]),_vm._v(" "+_vm._s(Object.keys(line).includes('lang') ? `${_vm.$t('locales')[`${Object.values(line)[0].split('_')[0]}`]}` : Object.values(line)[0])+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }